import {useNavigate} from "react-router-dom";
import moment from "moment";
import {useUser} from "../../../../util/userContext/UserContext";
import {useReadTopicType} from "../hooks";
import {useEditFaq} from "../hooks/useEditFaq";
import {useEffect} from "react";
import {UpdateFaqApiProps} from "../../../../types/support/faq";
import {FreedomEditor} from "../../../../components/common/FreedomEditor";
import {useReadProductGroup} from "../hooks/useReadProductGroup";

export const FaqDetailInput = () => {
    const navigate = useNavigate();
    const {user} = useUser();
    const {data: topicTypeData} = useReadTopicType();
    const {data: groupData} = useReadProductGroup();
    const {inputData, setInputData, onChangeInputData, saveFaq, removeFile, UploadUI, handleButtonClick} = useEditFaq();

    // useEffect(() => {
    //     if (topicTypeData && !inputData?.faqId)
    //         setInputData((prev: any) => ({
    //             ...prev, topicTypeIdx: topicTypeData[0]?.idx ?? 0
    //         }));
    // }, [topicTypeData]);

    const group = (groupData ?? []).find(g => g.newProductGroupid === inputData?.newProductGroupid);
    const UserNameAndRegAt = () => {
        if (inputData?.faqId) {
            return `${inputData?.userName} | ${inputData?.regAt}`;
        } else {
            return `${user?.userName} | ${moment().format("YYYY-MM-DD")}`;
        }
    }
    
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">FAQ 등록/수정</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-primary w-100px h-38px"
                                onClick={() => saveFaq(inputData as UpdateFaqApiProps)}>저장
                        </button>
                        <button
                            className="btn btn-outline-secondary w-100px h-38px"
                            onClick={() => inputData.faqId ? navigate(`${process.env.PUBLIC_URL}/support/faq/detail/${inputData.faqId}`, {replace: true})
                                : navigate(-1)}>
                            취소
                        </button>
                    </div>
                </div>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detailx">
                        <tbody>
                        <tr>
                            <th colSpan={2} style={{width: "12.5%"}}>제목</th>
                            <td className="p-4px">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={inputData?.title ?? ''}
                                    name={"title"}
                                    onChange={e => onChangeInputData(e)}/>
                            </td>
                        </tr>
                        <tr>
                            <th colSpan={2}>작성자/등록일</th>
                            <td>{UserNameAndRegAt()}</td>
                        </tr>
                        <tr>
                            <th rowSpan={5}>기본정보</th>
                            <th style={{width: "6.5%"}}>유형</th>
                            <td className="p-4px">
                                <select
                                    className="form-select w-150px"
                                    value={inputData?.topicTypeIdx}
                                    name={"topicTypeIdx"}
                                    onChange={e => onChangeInputData(e)}>
                                    {topicTypeData?.map((item: any) => <option
                                        value={item.idx}>{item.codeEntriesName}</option>)}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>제품군</th>
                            <td className="p-4px">
                                <select
                                    className="form-select w-150px"
                                    value={inputData?.newProductGroupid}
                                    name={"newProductGroupid"}
                                    onChange={e => onChangeInputData(e)}>
                                    <option value={""}>선택</option>
                                    {groupData?.map((item: any) => <option
                                        value={item.newProductGroupid}>{item.newName}</option>)}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>벤더</th>
                            <td className="p-4px">
                                {group?.productVendor}
                            </td>
                        </tr>
                        <tr>
                            <th>카테고리</th>
                            <td className="p-4px">
                                {group?.productCategory}
                            </td>
                        </tr>
                        <tr>
                            <th>구분</th>
                            <td className="p-4px">
                                <select
                                    className="form-select w-150px"
                                    value={inputData?.isNotice}
                                    name={"isNotice"}
                                    onChange={e => onChangeInputData(e)}>
                                    <option value={"N"}>일반</option>
                                    <option value={"Y"}>공지</option>
                                    <option value={"U"}>비활성화</option>
                                </select>
                            </td>
                        </tr>
                        <tr style={{height: "249px"}}>
                            <th colSpan={2}>내용</th>
                            <td className="p-4px" style={{verticalAlign: "top"}}>
                                <FreedomEditor
                                    setValue={setInputData}
                                    value={inputData?.body ?? ''}
                                    fieldName={'body'}/>
                            </td>
                        </tr>
                        <tr>
                            <th colSpan={2}>첨부파일</th>
                            <td className="p-4px">
                                <div className="tbl_files_outer">
                                    {inputData?.fileVOList.length !== 0 && <ul className="list_files">
                                        {(inputData?.fileVOList ?? []).map((item: any) => <li>
                                            <a>{item.fileOrgname}</a>
                                            <button
                                                className="btn btn-link p-0"
                                                onClick={() => removeFile(item.fileKey)}>
                                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"}
                                                     alt=""/>
                                            </button>
                                        </li>)}
                                    </ul>}
                                    <button
                                        className="btn btn-outline-secondary"
                                        onClick={() => handleButtonClick()}>파일 업로드
                                    </button>
                                    <UploadUI/>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}